/** Format a dollar amount. Shows 2 decimal places only when there are cents. */
export const formatDollars = (amount: number): string => {
  const hasCents = amount % 1 !== 0;
  return `$${amount.toLocaleString(undefined, { minimumFractionDigits: hasCents ? 2 : 0, maximumFractionDigits: 2 })}`;
};
